const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);

const shouldKeepConsoleLogs =
  process.env.NODE_ENV === "production" &&
  TRUE_VALUES.has(
    String(process.env.REACT_APP_ENABLE_PROD_LOGS || "")
      .trim()
      .toLowerCase(),
  );
const shouldDisableConsoleLogs =
  process.env.NODE_ENV === "production" && !shouldKeepConsoleLogs;

if (
  shouldDisableConsoleLogs &&
  typeof window !== "undefined" &&
  window.console
) {
  const noop = () => {};
  const knownConsoleMethods = [
    "assert",
    "clear",
    "count",
    "countReset",
    "debug",
    "dir",
    "dirxml",
    "error",
    "group",
    "groupCollapsed",
    "groupEnd",
    "info",
    "log",
    "profile",
    "profileEnd",
    "table",
    "time",
    "timeEnd",
    "timeLog",
    "timeStamp",
    "trace",
    "warn",
  ];
  const consoleMethods = new Set([
    ...knownConsoleMethods,
    ...Object.getOwnPropertyNames(window.console),
  ]);
  const originalConsole = {};

  consoleMethods.forEach((method) => {
    if (typeof window.console[method] === "function") {
      originalConsole[method] = window.console[method];
    }
  });

  if (!window.__TENK_ORIGINAL_CONSOLE__) {
    Object.defineProperty(window, "__TENK_ORIGINAL_CONSOLE__", {
      value: originalConsole,
      enumerable: false,
      configurable: false,
      writable: false,
    });
  }

  consoleMethods.forEach((method) => {
    if (typeof window.console[method] === "function") {
      try {
        window.console[method] = noop;
      } catch {
        // Some browser devtools implementations expose read-only methods.
      }
    }
  });
}
